import { Timestamp } from 'firebase/firestore';
import { computeEffectiveTable, generateInvoice, legacyTimeslotsToPricingPolicies, TDR, toLuxon } from 'tdr-common';
import getReservationInvoice from '../api/getReservationInvoice';

export const getNewInvoiceForModifiedTable = async ({
	restaurant,
	newTable,
	newGuestCount,
	newBookingTime,
	existingReservation,
	basePolicies
}: {
	restaurant: TDR.Restaurant;
	newTable: TDR.Table;
	newGuestCount: number;
	newBookingTime: Timestamp;
	existingReservation: TDR.Reservation;
	basePolicies: TDR.PricingPolicy[];
}): Promise<Partial<TDR.Invoice>> => {
	const tableOverridePolicies = legacyTimeslotsToPricingPolicies(restaurant, [newTable]);
	const policies = [...tableOverridePolicies, ...basePolicies];
	const existingInvoice = await getReservationInvoice(existingReservation.id);

	// Booking type is per-scenario: an override can make a table request-only on one date or for one
	// party size and instant on the next. generateInvoice reads it off `tableInfo`, so resolve the
	// CANDIDATE table against the state being priced -- the new date and party size it would move to,
	// not the table's default.
	const effectiveNewTable = computeEffectiveTable(
		toLuxon(newBookingTime, restaurant.timezone || 'UTC'),
		restaurant,
		newTable,
		{ groupSize: newGuestCount }
	);

	const newReservation: TDR.Reservation = {
		...existingReservation,
		guests: newGuestCount,
		time: newBookingTime,
		tableId: newTable.id,
		items: [
			...existingReservation.items.filter((item) => item.type !== TDR.Reservation.ItemType.Table),
			{
				id: newTable.id,
				type: TDR.Reservation.ItemType.Table,
				label: newTable.label,
				tags: newTable.tags
			}
		]
	};

	const newInvoice = generateInvoice(
		restaurant.currency,
		policies,
		newReservation,
		existingInvoice,
		restaurant,
		existingReservation,
		effectiveNewTable
	);

	return newInvoice;
};
